export default "__VITE_ASSET__BLKfj6FO__"